export default "__VITE_ASSET__TAwNt7Bp__"